import { NativeContext } from 'lavva.webview/build/js/Services/Common/ICommonService';
import { useGraphqlContext } from '../../context/graphql';
import { useNativeFunctionsContext } from '../../context/native-functions';

export const useAppSuspension = () => {
  const { handleRefresh } = useGraphqlContext();
  const { nativeCtx } = useNativeFunctionsContext();

  const onReturnFromSuspension = () => {
    console.log('Returned from suspension', nativeCtx);

    if (nativeCtx === NativeContext.AndroidGecko || nativeCtx === NativeContext.IosWebkit) {
      handleRefresh();
    }
  };

  return {
    onReturnFromSuspension,
  };
};
